var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSs = function SvgSs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 336h640v144H0z",
    fill: "#078930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 144h640v192H0z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v144H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 168h640v144H0z",
    fill: "#da121a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l415.7 240L0 480z",
    fill: "#0f47af"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7 194.85L61.75 240l138.95 45.15-85.85-118.2v146.1z",
    fill: "#fcdd09"
  })));
};
export default __webpack_public_path__ + "assets/b765e4253c143da083622586affab604.svg";
export { SvgSs as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ss.svg